"use client";

import * as React from "react";
import { FileText, Zap, Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowArmyWritingToolsWorks() {
  const {
    ref: step1Ref,
    isVisible: step1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: step2Ref,
    isVisible: step2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: step3Ref,
    isVisible: step3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const steps = [{
    icon: FileText,
    number: "1",
    title: "Select Document Type",
    description: "Choose NCOER bullets, award citations, or counseling statements",
    ref: step1Ref,
    isVisible: step1Visible
  }, {
    icon: Zap,
    number: "2",
    title: "Input Your Details",
    description: "Provide key information and achievements in simple prompts",
    ref: step2Ref,
    isVisible: step2Visible
  }, {
    icon: Check,
    number: "3",
    title: "Get Regulation-Ready Output",
    description: "Receive DA PAM 623-3 compliant, mission-ready documentation instantly",
    ref: step3Ref,
    isVisible: step3Visible
  }];
  return <section id="how-army-writing-tools-works" className="bg-background py-24 px-6 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">
            How Army Writing Tools Works
          </h2>
          <p className="mt-4 text-lg text-muted-foreground contrast-more:text-foreground">
            Three simple steps to regulation-compliant Army documentation
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} ref={step.ref} className={`group relative flex flex-col items-center text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${step.isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-lg bg-primary-light text-primary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:-translate-y-1">
                  <Icon className="h-10 w-10" />
                </div>

                <Badge variant="outline" className="mb-4 border-2 border-muted px-4 py-2 text-base font-bold text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:border-primary group-hover:shadow-soft">
                  {step.number}
                </Badge>

                <h3 className="mb-3 font-display text-xl font-semibold text-foreground">
                  {step.title}
                </h3>

                <p className="text-sm leading-relaxed text-muted-foreground contrast-more:text-foreground">
                  {step.description}
                </p>

                {i < steps.length - 1 && <div className="absolute -right-6 top-10 hidden h-0.5 w-12 bg-muted md:block" />}
              </div>;
        })}
        </div>
      </div>
    </section>;
}